export default __webpack_public_path__ + "static/media/location_preview_planetarium.454e831f.svg";